// extracted by mini-css-extract-plugin
module.exports = {"block":"OrganizationLevelFilter_block__RBNQe"};